import {Abstract} from "./Abstract";
import pageHtml from './page.html?raw';
import page_inner_templateHtml from './page.inner.template.html?raw';

export let template = pageHtml.replace(/<!-- INNER_TEMPLATE -->/gm, page_inner_templateHtml);

export class viewModel extends Abstract {
    /** Prefix each cssClass token with `btn-` (e.g. `action btn-back` → `btn-action btn-back`). */
    protected override cssClass(): string {
        return super.cssClass()
            .split(/\s+/)
            .filter(Boolean)
            .map((c) => (c === 'disabled' || c.startsWith('btn-') ? c : `btn-${c}`))
            .join(' ');
    }
}
